import { introductoryOfferSkuByProductIdLookup, skuByProductIdLookup } from '../constants/product-to-sku-lookup';

const fallback = {
  status: 'not-found',
  fallbackSku: skuByProductIdLookup.defaultSku,
} as const;

export const getSkuByProductId = ({
  productId,
}: {
  productId: string | null;
}):
  | { status: 'success'; sku: string }
  | { status: 'not-found'; fallbackSku: typeof skuByProductIdLookup.defaultSku } => {
  if (!productId) {
    return fallback;
  }

  const sku = skuByProductIdLookup[productId];

  if (sku) {
    return {
      status: 'success',
      sku,
    };
  }

  return fallback;
};

export const getIntroductoryOfferSkuByProductId = ({ productId }: { productId: string }): string | undefined => {
  return introductoryOfferSkuByProductIdLookup[productId];
};

export const getDefaultSku = (): string => {
  return skuByProductIdLookup.defaultSku;
};
